import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import * as fromAuthUserGql from '../store/entities/uaa/auth-user.graphql';
import {BaseResponse} from '../common/interfaces/global-interfaces';
import {AuthUserActions} from '../store/entities/uaa/auth-user.actions';
import {AppState} from '../store';
import {Store} from '@ngrx/store';
import {NgxPermissionsService} from 'ngx-permissions';
import {NotificationService} from './notification.service';
import {AuthService} from './auth.service';
import {GraphqlService} from './graphql.service';
import {InactivityTimerService} from "./inactivity-timer.service";
import {AuthUserProfile} from "../store/entities/uaa/auth-user.model";

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  constructor(
    private store: Store<AppState>,
    private storageService: StorageService,
    private graphqlService: GraphqlService,
    private permissionsService: NgxPermissionsService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private inactivityTimerService: InactivityTimerService,
  ) {}


  async authRole() {
    if (this.authService.alreadyLoggedIn()) {
      // start session timeout from here
      this.inactivityTimerService.startTimer();
      await this.getUserProfileAndRoles();
    }
  }

  async getUserProfileAndRoles () {
    try {
      const response: any = await this.graphqlService.query({
        query: fromAuthUserGql.GET_USER_PROFILE_AND_ROLES,
      });
      const result: BaseResponse<AuthUserProfile> = Object.values(
        Object.values(response)[0]
      )[0];
      if (result?.response?.status) {
        const authUser: AuthUserProfile = result?.data ?? {};
        this.store.dispatch(AuthUserActions.loadAuthUsers({ authUsers: [authUser] }));

        const permsObject = authUser?.userRole?.permissions;
        this.storageService.set('userProfile', authUser)
        this.storageService.set('userInstitution', authUser?.userInstitution)

        this.storageService.set('accountType', authUser?.userProfile?.accountType);

        const permissions: string[] = !!permsObject ? permsObject?.map(
          (res: any) => res?.permissionCode
        ) : [];

        // this permission is added specifically for routes/endpoints that don't need to bound with a permission.
        permissions.push('NO_PERMISSION');
        if (permissions?.length > 0) {
          this.permissionsService.loadPermissions(permissions);
        }
        // console.log(permissions, 'permissions');
        this.authService.monitorRefreshToken();
      } else {
        this.notificationService.errorSnackbar(result?.response?.message);
        await this.authService.logout();
      }
    } catch (e) {
      await this.authService.logout();
      this.notificationService.errorSnackbar(e.message);
    }
  }

}
